import React, { useState, useEffect, useRef } from "react"
import { EditorState, convertToRaw, ContentState } from "draft-js"
import { Editor } from "react-draft-wysiwyg"
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"
import draftToHtml from "draftjs-to-html"
import htmlToDraft from "html-to-draftjs"

const FBEditor = ({ prevData, htmlData, setHtmlData }) => {
  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  )
  const initialized = useRef(false)

  const handleChange = e => {
    setEditorState(e)
  }

  useEffect(() => {
    if (!initialized.current && prevData) {
      const contentBlock = htmlToDraft(prevData)
      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(
          contentBlock.contentBlocks
        )
        const value = EditorState.createWithContent(contentState)
        setEditorState(value)
      }
      initialized.current = true
    }
  }, [prevData])

  useEffect(() => {
    if (editorState) {
      setHtmlData(draftToHtml(convertToRaw(editorState.getCurrentContent())))
    }
  }, [editorState])

  return (
    <div>
      <Editor
        editorState={editorState}
        wrapperClassName="demo-wrapper"
        editorClassName="demo-editor"
        onEditorStateChange={handleChange}
      />
    </div>
  )
}
export default FBEditor
